import {
  GET_DEVICES,
  GET_DEVICES_SUCCESS,
  GET_DEVICES_FAIL,
  ADD_DEVICES_SUCCESS,
  ADD_DEVICES_FAIL,
  UPDATE_DEVICES_SUCCESS,
  UPDATE_DEVICES_FAIL,
  RESET_DEVICE_MESSAGE,
  UNPAIR_DEVICES_SUCCESS,
  UNPAIR_DEVICES_FAIL,
} from "./actionTypes";

const initialState = {
  devices: [],
  loadingDevices: false,
  success: {
    message: "",
  },
  error: {
    message: "",
  },
};

const DevicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_DEVICE_MESSAGE:
      state = {
        ...state,
        success: {
          message: "",
        },
        error: {
          message: "",
        },
      };
      break;
    case GET_DEVICES:
      state = { ...state, loadingDevices: true };
      break;
    case GET_DEVICES_SUCCESS:
      state = { ...state, devices: action.payload, loadingDevices: false };
      break;
    case GET_DEVICES_FAIL:
      state = {
        ...state,
        error: action.payload,
        loadingDevices: false,
      };
      break;
    case ADD_DEVICES_SUCCESS:
      state = { ...state, success: action.payload, loadingDevices: false };
      break;
    case ADD_DEVICES_FAIL:
      state = {
        ...state,
        error: action.payload,
        loadingDevices: false,
      };
      break;
    case UPDATE_DEVICES_SUCCESS:
      state = { ...state, success: action.payload, loadingDevices: false };
      break;
    case UPDATE_DEVICES_FAIL:
      state = {
        ...state,
        error: action.payload,
        loadingDevices: false,
      };
      break;
    case UNPAIR_DEVICES_SUCCESS:
      console.log("haha", action);
      state = { ...state, success: action.payload, loadingDevices: false };
      break;
    case UNPAIR_DEVICES_FAIL:
      state = {
        ...state,
        error: action.payload,
        loadingDevices: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default DevicesReducer;
